import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconArrowDownComponent } from "./med-icon-arrow-down.component";

@NgModule({
  declarations: [
    MedIconArrowDownComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconArrowDownComponent,
  ],
})
export class MedIconArrowDownModule { }
